import { requestWithQuery } from '../../../shared/api/utils/provider';
import { ApiResponse } from '../../../shared/api/utils/responseTransform';
import { LiveAlertDetails } from '../../types/alert';
import { MessagesAndCallsListItem, MessagesAndCallsQueryParams } from '../../types/messagesAndCalls';
import { OrganizerDetails } from '../../types/organizer';
import { RideOverviewDetails } from '../../types/rideOverview';
import { IRiderAssistantDetails } from '../../types/riderAssistant';
import { DriverDetails, EditRideDetails, RideDetails, RideListItem, RideNotes } from '../../types/rides';

export async function getRideDetails(slug): Promise<ApiResponse<RideDetails>> {
  return requestWithQuery({ url: `/care/rides/${slug}/details`, method: 'GET' });
}

export async function getDriverDetails(slug): Promise<ApiResponse<DriverDetails>> {
  return requestWithQuery({ url: `/care/rides/${slug}/driver`, method: 'GET' });
}

export async function getRideNotes(slug): Promise<ApiResponse<RideNotes>> {
  return requestWithQuery({ url: `/care/rides/${slug}/ride_notes`, method: 'GET' });
}
export async function getOrganizerDetails(rideSlug, organizerSlug): Promise<ApiResponse<OrganizerDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/organizers/${organizerSlug}`, method: 'GET' });
}

export async function addRideNote(rideSlug, data): Promise<ApiResponse<RideNotes>> {
  return requestWithQuery({ url: `/care/admin_notes.json?id=${rideSlug}&resource=ride`, method: 'PATCH', data: data });
}
export async function editRideDetails(rideSlug, data): Promise<ApiResponse<EditRideDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}`, method: 'PATCH', data: data });
}
export async function cancelRide(rideSlug, data): Promise<ApiResponse> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/cancel`, method: 'POST', data: data });
}

export async function rebuildRideDetails(rideSlug, data): Promise<ApiResponse<{ rebuiltRideSlug: string }>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/rebuild`, method: 'POST', data: data });
}
export async function unclaimRide(rideSlug, data): Promise<ApiResponse<RideDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/unclaim`, method: 'POST', data: data });
}
export async function getRideOverviewDetails(rideSlug): Promise<ApiResponse<RideOverviewDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/overview`, method: 'GET' });
}

export type RidesQueryParams = {
  page?: number;
  perPage?: number;
  startDatetime?: string;
  endDatetime?: string;
  states?: string[];
  userId?: string;
  view?: 'slim' | 'default';
};

export async function getRides(query: RidesQueryParams): Promise<ApiResponse<RideListItem>> {
  return requestWithQuery({ url: '/care/rides', method: 'GET', params: query });
}

export async function updateTimestamps(rideSlug, data): Promise<ApiResponse<RideDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/timestamps`, method: 'PATCH', data: data });
}

export async function getMessagesAndCalls(
  query: MessagesAndCallsQueryParams
): Promise<ApiResponse<MessagesAndCallsListItem>> {
  return requestWithQuery({ url: '/care/communications', method: 'GET', params: query });
}
export async function getAdjustedArrivalReasons(): Promise<ApiResponse<[string, string][]>> {
  return requestWithQuery({ url: '/care/arrival_window_adjustment_reasons', method: 'GET' });
}

export async function getLiveAlerts(rideSlug: string): Promise<ApiResponse<LiveAlertDetails[]>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/live_alerts`, method: 'GET' });
}

export async function removeRiders(rideSlug, data): Promise<ApiResponse> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/remove_riders`, method: 'POST', data: data });
}

export async function getRiderAssistantOnRide(rideSlug: string): Promise<ApiResponse<IRiderAssistantDetails>> {
  return requestWithQuery({ url: `/care/rides/${rideSlug}/rider_assistant`, method: 'GET' });
}
